module.exports = __webpack_public_path__ + "static/media/digging.6b0a3b67.svg";